module.exports = __webpack_public_path__ + "img/10-TAMARIN_min.db4dff98.jpg";